import { render, staticRenderFns } from "./makeUp.vue?vue&type=template&id=740612e6&scoped=true&"
import script from "./makeUp.vue?vue&type=script&lang=js&"
export * from "./makeUp.vue?vue&type=script&lang=js&"
import style0 from "./makeUp.vue?vue&type=style&index=0&id=740612e6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740612e6",
  null
  
)

export default component.exports